/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalAgreementLanguage } from './';
import {
    LegalAgreementLanguageFromJSON,
    LegalAgreementLanguageFromJSONTyped,
    LegalAgreementLanguageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AcceptLegalAgreementRequest
 */
export interface AcceptLegalAgreementRequest {
    /**
     * Identifier of the published legal agreement version to accept.
     * @type {string}
     * @memberof AcceptLegalAgreementRequest
     */
    versionId: string;
    /**
     * 
     * @type {LegalAgreementLanguage}
     * @memberof AcceptLegalAgreementRequest
     */
    language: LegalAgreementLanguage;
}

/**
 * Check if a given object implements the AcceptLegalAgreementRequest interface.
 */
export function instanceOfAcceptLegalAgreementRequest(value: object): value is AcceptLegalAgreementRequest {
    if (!('versionId' in value) || value['versionId'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    return true;
}

export function AcceptLegalAgreementRequestFromJSON(json: any): AcceptLegalAgreementRequest {
    return AcceptLegalAgreementRequestFromJSONTyped(json, false);
}

export function AcceptLegalAgreementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptLegalAgreementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'versionId': json['versionId'],
        'language': LegalAgreementLanguageFromJSON(json['language']),
    };
}

export function AcceptLegalAgreementRequestToJSON(value?: AcceptLegalAgreementRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'versionId': value['versionId'],
        'language': LegalAgreementLanguageToJSON(value['language']),
    };
}

